const PARIS_TIME_ZONE = 'Europe/Paris'

const parisFormatter = new Intl.DateTimeFormat('fr-CA', {
  timeZone: PARIS_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
})

function parisParts(timestampMs: number): Record<string, number> {
  return Object.fromEntries(
    parisFormatter
      .formatToParts(new Date(timestampMs))
      .filter(part => part.type !== 'literal')
      .map(part => [part.type, Number(part.value)]),
  )
}

function parisOffsetMs(timestampMs: number): number {
  const parts = parisParts(timestampMs)
  const representedAsUtc = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second,
  )
  return representedAsUtc - Math.floor(timestampMs / 1000) * 1000
}

export function isoToParisDateTimeInput(
  value: string | null | undefined,
  includeSeconds = false,
): string {
  if (!value) return ''
  const timestampMs = new Date(value).getTime()
  if (!Number.isFinite(timestampMs)) return ''
  const parts = parisParts(timestampMs)
  const pad = (part: number) => String(part).padStart(2, '0')
  const minuteValue = `${parts.year}-${pad(parts.month)}-${pad(parts.day)}T${pad(parts.hour)}:${pad(parts.minute)}`
  return includeSeconds ? `${minuteValue}:${pad(parts.second)}` : minuteValue
}

export function parisDateTimeInputToIso(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value)
  if (!match) return ''
  const [, year, month, day, hour, minute, second = '0'] = match
  const wallTimeAsUtc = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
  )
  let timestampMs = wallTimeAsUtc - parisOffsetMs(wallTimeAsUtc)
  timestampMs = wallTimeAsUtc - parisOffsetMs(timestampMs)
  return new Date(timestampMs).toISOString()
}
